import LombaBasket from "../../../../assets/img/illustrations/basket.svg";
import LombaFutsal from "../../../../assets/img/illustrations/football.svg";
import LombaDance from "../../../../assets/img/illustrations/dance.svg";
import BasketBall from "../../../../assets/img/illustrations/basket-ball.svg";
import Ball from "../../../../assets/img/illustrations/bola.svg";
import Dance from "../../../../assets/img/illustrations/dance-header.svg";
import Juara1 from "../../../../assets/img/illustrations/juara-1.svg";
import Juara2 from "../../../../assets/img/illustrations/juara-2.svg";
import Juara3 from "../../../../assets/img/illustrations/juara-3.svg";
import LombaFutsalBlitar from "../../../../assets/img/illustrations/futsal-blitar.svg";
import LombaFutsalSMPBlitar from "../../../../assets/img/illustrations/futsal-smp.png";
import LombaFutsalSMA2026 from "../../../../assets/img/illustrations/futsal-sma-2026.png";
import LombaFutsalSMP2026 from "../../../../assets/img/illustrations/futsal-smp-2026.png";
import LombaFutsalKuliah2026 from "../../../../assets/img/illustrations/futsal-kuliah-2026.png";
import { func } from "../../../../utils";
// import LombaFutsalSMPBlitar from "../../../../assets/img/illustrations/futsal-smp-blitar.svg";

const basicChampionPrice = [
  {
    title: "Juara 1",
    icon: Juara1,
  },
  {
    title: "Juara 2",
    icon: Juara2,
  },
  {
    title: "Juara 3",
    icon: Juara3,
  },
];

export const cardLomba = [
  {
    id: 1,
    title: "Basket",
    img: LombaBasket,
    cardClass: "basket",
    activeBgColor: "#00BCF1",
    iconActiveBgColor: "#0397C9",
    activeColor: "#DAF7FF",
  },
  {
    id: 2,
    title: "Futsal",
    img: LombaFutsal,
    cardClass: "futsal",
    activeBgColor: "#77B341",
    iconActiveBgColor: "#578B2D",
    activeColor: "#d6ecc1",
  },
  {
    id: 3,
    title: "Dance",
    img: LombaDance,
    cardClass: "dance",
    activeBgColor: "#c7b1e1",
    iconActiveBgColor: "#9f78cb",
    activeColor: "#d4cfe5",
  },
];

export const cardLombaNew = [
  {
    id: 1,
    title: "Futsal SMA",
    img: LombaFutsalBlitar,
    cardClass: "basket",
    activeBgColor: "#00BCF1",
    iconActiveBgColor: "#0397C9",
    activeColor: `url(${func.getStaticImg(
      "/bg/bg-swoosh-blur.png",
    )}) #1F2D3D 100% / cover no-repeat`,
  },
  {
    id: 2,
    title: "Futsal SMP",
    img: LombaFutsalSMPBlitar,
    cardClass: "futsal",
    activeBgColor: "#77B341",
    iconActiveBgColor: "#578B2D",
    activeColor: `url(${func.getStaticImg(
      "/bg/bg-swoosh-blur.png",
    )}) #1F2D3D 100% / cover no-repeat`,
  },
];

// 2026 Jadwal design: 3 categories (SMA/SMP/Kuliah), new avatars, "selected = light
// blue" per design. Kept separate from cardLombaNew so Klasemen/landing (binary SMA/SMP
// logic) aren't forced to render a 3rd, unwired card.
export const cardLombaJadwal = [
  {
    id: 1,
    title: "SMA",
    img: LombaFutsalSMA2026,
    activeBgColor: "#137FAA",
    iconActiveBgColor: "#00BCF1",
  },
  {
    id: 2,
    title: "SMP",
    img: LombaFutsalSMP2026,
    activeBgColor: "#137FAA",
    iconActiveBgColor: "#00BCF1",
  },
  {
    id: 3,
    title: "Perguruan Tinggi",
    img: LombaFutsalKuliah2026,
    activeBgColor: "#137FAA",
    iconActiveBgColor: "#00BCF1",
    titleSize: "16px", // shrink so the long label stays on one line in the equal-width card
  },
];

export const cardContentLomba = [
  {
    id: 1,
    title: "Basket",
    sectionClass: "basket-section",
    headerClass: "basket-header",
    eventGTM: "daftarSekarang_basket",
    description: {
      title: "Persyaratan: ",
      list: [
        "Peserta merupakan sekolah setingkat SMA, SMK atau MA di Kota/  Kabupaten Semarang dan sekitarnya.",
        "1 tim terdiri maksimal 15 peserta yang merupakan siswa aktif di sekolah tersebut yang ditunjukkan dengan validasi Kartu Pelajar atau Nomor Induk Siswa Nasional (NISN) dan Surat Rekomendasi / Surat Izin dari sekolahnya.",
        "Peserta melakukan pendaftaran melalui web pialabyu.com dan dinyatakan terverifikasi oleh panitia untuk mengikuti kejuaraan.",
        "Setiap tim yang terpilih akan mendapatkan kompensasi / benefit pembuatan jersey / seragam tim dengan logo branding by.U.",
        "Biaya akomodasi di Kota Semarang selama pertandingan ditanggung oleh sekolah peserta.",
        "Cabang olahraga basket hanya untuk tim putra.",
        "1 sekolah hanya diperbolehkan mendaftarkan 1 tim peserta.",
      ],
      boldWord: ["tim putra"],
      footer: "",
      url: "https://www.byu.id/v2/event/piala-by-u-lomba-basket",
    },
    iconhHeader: BasketBall,
    championList: [
      { ...basicChampionPrice[0], price: "Rp 10 Juta" },
      { ...basicChampionPrice[1], price: "Rp 7,5 Juta" },
      { ...basicChampionPrice[2], price: "Rp 5 Juta" },
    ],
  },
  {
    id: 2,
    title: "Futsal",
    sectionClass: "futsal-section",
    headerClass: "futsal-header",
    eventGTM: "daftarSekarang_futsal",
    description: {
      title: "Persyaratan: ",
      list: [
        "Peserta merupakan sekolah setingkat SMA, SMK atau MA di Kota/  Kabupaten Semarang dan sekitarnya.",
        "1 tim terdiri maksimal 15 peserta yang merupakan siswa aktif di sekolah tersebut yang ditunjukkan dengan validasi Kartu Pelajar atau Nomor Induk Siswa Nasional (NISN) dan Surat Rekomendasi / Surat Izin dari sekolahnya.",
        "Peserta melakukan pendaftaran melalui web pialabyu.com dan dinyatakan terverifikasi oleh panitia untuk mengikuti kejuaraan.",
        "Setiap tim yang terpilih akan mendapatkan kompensasi / benefit pembuatan jersey / seragam tim dengan logo branding by.U.",
        "Biaya akomodasi di Kota Semarang selama pertandingan ditanggung oleh sekolah peserta.",
        "Cabang olahraga futsal hanya untuk \ntim putra",
        "Setiap sekolah hanya diperbolehkan mendaftarkan 1 tim peserta.",
      ],
      boldWord: ["tim putra"],
      footer: "",
      url: "https://www.byu.id/v2/event/piala-by-u-lomba-futsal",
    },
    iconhHeader: Ball,
    championList: [
      { ...basicChampionPrice[0], price: "Rp 10 Juta" },
      { ...basicChampionPrice[1], price: "Rp 7,5 Juta" },
      { ...basicChampionPrice[2], price: "Rp 5 Juta" },
    ],
  },
  {
    id: 3,
    title: "Dance",
    sectionClass: "dance-section",
    headerClass: "dance-header",
    eventGTM: "daftarSekarang_dance",
    description: {
      title: "Persyaratan: ",
      list: [
        "Peserta merupakan siswa sekolah setingkat SMA, SMK atau MA di Kota/  Kabupaten Semarang dan sekitarnya.",
        "1 tim terdiri dari 5 sampai dengan 12 orang peserta yang merupakan siswa aktif di sekolah tersebut yang ditunjukkan dengan validasi Kartu Pelajar atau Nomor Induk Siswa Nasional (NISN) dan Surat Rekomendasi / Surat Izin dari sekolahnya.",
        "Peserta melakukan pendaftaran melalui web pialabyu.com dan dinyatakan terverifikasi oleh panitia untuk mengikuti kejuaraan.",
        "Biaya akomodasi di Kota Semarang selama pertandingan ditanggung oleh sekolah peserta.",
      ],
      title2: "Ketentuan Dance: ",
      list2: [
        "Dance berdurasi 3-4 menit.",
        'Dance memuat lagu "Pink Venom" by Black Pink ATAU "Ice on My Baby" by Yung Bleu yang dapat dikreasikan (di-remix) dengan lagu lainnya.',
        "Konten Dance tidak memuat pornografi atau menyinggung SARA.",
      ],
      boldWord: [],
      footer: {
        title: "Kriteria Penilaian: ",
        list: [
          "Keindahan gerakan",
          "Kreativitas gerak",
          "Detail gerakan",
          "Kostum",
          "Kesesuaian gerak dengan musik",
          "Ekspresi",
        ],
      },
      url: "https://www.byu.id/v2/event/piala-by-u-lomba-dance",
    },
    iconhHeader: Dance,
    championList: [
      { ...basicChampionPrice[0], price: "Rp 2,5 Juta" },
      { ...basicChampionPrice[1], price: "Rp 1,75 Juta" },
      { ...basicChampionPrice[2], price: "Rp 1 Juta" },
    ],
  },
];
